'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { css, styled } from '@mui/material/styles';
import { forwardRef } from 'react';
const StyledField = styled('button')(({ theme }) => css `
    border: unset;
    outline: unset;

    border-radius: ${theme.tokens.FuelBorderRadiusMd};
    position: relative;
    text-align: left;
    color: ${theme.tokens.FuelColorGray700};
    font-family: ${theme.tokens.FuelFontFamilyBase};
    font-weight: ${theme.tokens.FuelFontWeightBase};
    font-size: ${theme.tokens.FuelFontSizeBase};

    box-shadow: inset 0 0 0 1px ${theme.tokens.FuelColorBorderDark};
    background-color: ${theme.tokens.FuelColorWhite};
    padding: ${theme.tokens.FuelSpacing2} ${theme.tokens.FuelSpacing2};

    box-sizing: border-box;

    display: flex;
    align-items: center;

    width: 100%;
    white-space: nowrap;
    line-height: 1.5rem;
    cursor: pointer;

    &:not(:disabled) {
        &:hover, &:focus-visible {
            box-shadow: inset  0 0 0 2px ${theme.tokens.FuelColorBlack};
        }
    }

    &:disabled {
        cursor: not-allowed;
        border-color: ${theme.tokens.FuelColorBorderDark};
        opacity: .4;
    }
`);
const StyledKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)(({ theme }) => ({
    fill: theme.tokens.FuelColorGray700,
    marginLeft: 'auto'
}));
const StyledKeyboardArrowDown = styled(KeyboardArrowDown)(({ theme }) => ({
    fill: theme.tokens.FuelColorGray700,
    marginLeft: 'auto'
}));
const StyledLabel = styled('span')(({ theme }) => ({
    display: 'flex',
    gap: theme.tokens.FuelSpacing2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}));
export const Field = forwardRef(({ children, id, ...props }, ref) => {
    const resolvedId = `${id ? `${id}-` : null}Field`;
    const labelId = `${resolvedId}-label`;
    return (_jsxs(StyledField, { ...props, "aria-labelledby": labelId, className: 'FuelSelect-field', ref: ref, type: 'button', children: [_jsx(StyledLabel, { id: labelId, children: children }), props['aria-expanded'] ? _jsx(StyledKeyboardArrowUpIcon, {}) : _jsx(StyledKeyboardArrowDown, {})] }));
});
Field.displayName = 'Field';
